import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function About() {
  const scrollToContact = () => {
    document
      .getElementById("contact")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Visual */}
          <div className="lg:col-span-5 order-2 lg:order-1 reveal">
            <div className="relative">
              <div className="absolute -inset-3 rounded-[32px] bg-gradient-to-tr from-orange-500/20 via-amber-300/10 to-transparent blur-xl" />
              <div className="relative rounded-[28px] overflow-hidden border border-slate-900/10 bg-white shadow-[0_30px_60px_-30px_rgba(15,23,42,0.3)]">
                <img
                  src="https://images.pexels.com/photos/5058925/pexels-photo-5058925.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  alt="Confident Black African executive leader"
                  className="w-full h-[520px] object-cover"
                  data-testid="about-image"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-6 -right-3 md:-right-6 max-w-[280px] bg-slate-900 text-white p-5 rounded-2xl shadow-xl">
                <div className="eyebrow !text-amber-400">Confident African Executive Leadership</div>
                <p className="mt-2 text-[13px] leading-relaxed text-amber-50/90">
                  Developing leaders with the judgement, communication and
                  strategic confidence to guide teams, manage change and drive
                  measurable organisational performance.
                </p>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7 order-1 lg:order-2 reveal">
            <span className="eyebrow" data-testid="about-eyebrow">
              About Ascentix
            </span>
            <h2
              data-testid="about-headline"
              className="font-display mt-4 text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-slate-900"
            >
              Built around your team. <br />
              <span className="text-slate-500">Designed for outcomes.</span>
            </h2>
            <p className="mt-7 text-[17px] leading-relaxed text-slate-600 max-w-[640px]">
              Ascentix Development Limited is a professional training and
              development organisation dedicated to empowering professionals
              and equipping teams for effective execution, sustainable growth
              and stronger customer relationships.
            </p>
            <p className="mt-4 text-[17px] leading-relaxed text-slate-600 max-w-[640px]">
              Our team brings together decades of corporate, local and global
              experience across business sectors, allowing us to design
              practical training solutions that align with each client's
              strategic objectives.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-5 max-w-[520px]">
              {[
                ["120+", "Years combined experience"],
                ["6", "Programme practice areas"],
                ["7+", "Sector clients served"],
                ["100%", "Tailored to your goals"],
              ].map(([k, v], i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="rounded-2xl border border-slate-900/5 bg-white p-5"
                >
                  <div className="font-display text-3xl text-orange-600">
                    {k}
                  </div>
                  <div className="text-[13px] text-slate-500 mt-1">{v}</div>
                </div>
              ))}
            </div>

            <Button
              data-testid="about-cta-discuss"
              onClick={scrollToContact}
              className="mt-9 rounded-full bg-slate-900 hover:bg-slate-800 text-white h-12 px-6 font-semibold"
            >
              Discuss Your Training Needs
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
